module.exports = __webpack_public_path__ + "static/media/gf.58ed92f8.svg";